import script from "./ModifyTime.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModifyTime.vue?vue&type=script&lang=ts&setup=true"

import "./ModifyTime.vue?vue&type=style&index=0&id=1beb750b&lang=css"

const __exports__ = script;

export default __exports__